<template>
  <div class="flex-start">
    <el-checkbox v-bind="$attrs" v-model="localChecked" @change="onChange">{{ label }}</el-checkbox>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'SettingsCheckbox',
    model: {
      prop: 'checked',
      event: 'change'
    },
    props: {
      checked: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        localChecked: this.checked
      }
    },
    watch: {
      checked(v) {
        this.localChecked = v
      }
    },
    created() {},
    mounted() {},
    methods: {
      onChange(v) {
        this.$emit('change', v)
      }
    }
  }
</script>
<style scoped lang="scss"></style>
